import { getCookie } from './cookie';

function isAnalyticsLogEnabled() {
  return 'true' === getCookie('assembler-debug');
}

function logAnalytics(logLevel: 'log' | 'warn', ...args: (object | string | number)[]) {
  if (isAnalyticsLogEnabled()) {
    console[logLevel](...args);
  }
}

function invokeTag(triedTimes = 0, eventName: string) {
  if (typeof window.digitaldata !== 'undefined' && triedTimes < 10) {
    if (typeof window._satellite !== 'undefined') {
      logAnalytics('log', 'ASSEMBLER ANALYTICS: calling satellite track with:', eventName);
      window._satellite.track(eventName);
    } else {
      setTimeout(() => invokeTag(++triedTimes, eventName), 500);
    }
  }
}

export function triggerMfeView(viewName: string, name: string) {
  logAnalytics('log', 'ASSEMBLER ANALYTICS: triggering mfe view:', viewName, name);

  window.digitaldata = { mfe: { viewName, name } };

  invokeTag(0, 'mfe-ready');
}

export function onAnalyticsEvent(eventName: string, data: object, attempts: number = 0) {
  const isLocked = window.isAnalyticsLocked;

  logAnalytics('log', 'ASSEMBLER ANALYTICS: on analytics event triggered:', eventName, data, attempts);

  if (attempts >= 10) {
    logAnalytics('warn', 'ASSEMBLER ANALYTICS: Failed to fire tag: ' + eventName + ', Retry attempts: ' + attempts);
    window.isAnalyticsLocked = false;
    return;
  }
  const analyticsRetryWaitTimeMs = 300;
  if (isLocked) {
    setTimeout(() => onAnalyticsEvent(eventName, data, ++attempts), analyticsRetryWaitTimeMs);
    return;
  }
  try {
    window.isAnalyticsLocked = true;
    window.digitaldata = data;
    invokeTag(0, eventName);
  } finally {
    setTimeout(() => {
      window.isAnalyticsLocked = false;
    }, analyticsRetryWaitTimeMs);
  }
}
